/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
 'use strict';

/**
 * Directive for our indicator which notifies users if they have new activities.
 */
 angular.module('bulbApp.activityModule')
 .directive('bulbActivityIndicator', bulbActivityIndicator);

function bulbActivityIndicator() {
   return {
     restrict: 'E',
     templateUrl: 'ajs/components/activity/activityindicator.html',
     controller: 'ActivityController as activityCtrl'
   };
 }
